var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 31C18.3431 31 17 32.3431 17 34C17 35.6569 18.3431 37 20 37L32 37C33.6569 37 35 35.6569 35 34C35 32.3431 33.6569 31 32 31L20 31Z",
    fill: "#618DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 46C17 44.3431 18.3431 43 20 43L32 43C33.6569 43 35 44.3431 35 46C35 47.6568 33.6569 49 32 49L20 49C18.3431 49 17 47.6569 17 46Z",
    fill: "#618DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19C18.3431 19 17 20.3431 17 22C17 23.6569 18.3431 25 20 25L32 25C33.6569 25 35 23.6569 35 22C35 20.3431 33.6569 19 32 19L20 19Z",
    fill: "#618DFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C8.13401 5 5 8.13401 5 12V68C5 71.866 8.134 75 12 75H54C57.866 75 61 71.866 61 68V61.8541L66.6584 64.6833C67.5883 65.1483 68.6927 65.0986 69.5772 64.552C70.4616 64.0053 71 63.0397 71 62V42.955C73.4958 39.9963 75 36.1738 75 32C75 23.6348 68.958 16.6808 61 15.2639V12C61 8.13401 57.866 5 54 5H12ZM58 49C60.4954 49 62.8653 48.4623 65 47.4965V57.1459L59.3416 54.3167C58.4971 53.8944 57.5029 53.8944 56.6584 54.3167L51 57.1459V47.4965C53.1347 48.4623 55.5046 49 58 49ZM41 32C41 36.1738 42.5042 39.9963 45 42.955V62C45 63.0397 45.5384 64.0053 46.4228 64.552C47.3073 65.0986 48.4117 65.1483 49.3416 64.6833L55 61.8541V68C55 68.5523 54.5523 69 54 69H12C11.4477 69 11 68.5523 11 68V12C11 11.4477 11.4477 11 12 11H54C54.5523 11 55 11.4477 55 12V15.2639C47.042 16.6808 41 23.6348 41 32ZM58 21C51.9249 21 47 25.9249 47 32C47 38.0751 51.9249 43 58 43C64.0751 43 69 38.0751 69 32C69 25.9249 64.0751 21 58 21Z",
    fill: "#618DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedal);
export default __webpack_public_path__ + "static/media/icon-medal.70a763a19d876cc3ec4d54982ea8a127.svg";
export { ForwardRef as ReactComponent };